import { useLocale } from "../i18n";
import { measurementNotice } from "../i18n/measurement";

export default function MeasurementNotice() {
  const { locale } = useLocale();
  const notice = measurementNotice[locale];
  return (
    <details className="measurement-notice">
      <summary>{notice.title}</summary>
      <p>{notice.text}</p>
    </details>
  );
}
